import {
  Box,
  Flex,
  List,
  StarFilledIcon,
  Typography,
} from '@iheartjane/reefer';

import { FilterCheckBox } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/filterCheckBox';
import {
  useProductSearchFilters,
  useSearchParamFilter,
} from '@jane/bloom/hooks/filters';
import { FilterCategoryLabel } from '@jane/bloom/hooks/filters/useProductSearchFilters';
import type { SearchFilterFacet } from '@jane/bloom/viewModels/productSearchFilters';

import { FilterActions } from './filterActions';

interface FilterRatingsButtonProps {
  availableProductsCount?: number;
  /** Injected by FilterButtonWrapper */
  closePopover?: () => void;
}

const filterKey = 'ratings';

export function FilterRatingsButton({
  availableProductsCount,
  closePopover,
}: FilterRatingsButtonProps) {
  const { getProductSearchFilterOptions } = useProductSearchFilters();
  const { clearFilter } = useSearchParamFilter(filterKey);
  const filterOptions = getProductSearchFilterOptions(
    filterKey
  ) as SearchFilterFacet[];

  return (
    <Box px={16} pt={16}>
      <List label={FilterCategoryLabel[filterKey]} mb={16}>
        {filterOptions.map((filterValue) => {
          const start = filterValue.start || 0;
          return (
            <FilterCheckBox
              filter={filterValue}
              filterKey={filterKey}
              key={filterValue.label}
              label={
                <Flex alignItems="center">
                  <Flex mr={8}>
                    {[...Array(start)].map((_v, k) => (
                      <StarFilledIcon size="sm" key={`filled-${k}`} />
                    ))}
                    {[...Array(filterOptions.length - start)].map((_v, k) => (
                      <StarFilledIcon
                        size="sm"
                        color="grays-light"
                        key={`unfilled-${k}`}
                      />
                    ))}
                  </Flex>
                  <Typography variant="body">
                    {filterValue.label}+&nbsp;stars ({filterValue.count})
                  </Typography>
                </Flex>
              }
            />
          );
        })}
      </List>
      <FilterActions
        availableProductsCount={availableProductsCount}
        handleClearAll={clearFilter}
        handleClose={closePopover}
        sticky
      />
    </Box>
  );
}
